import { CustomElement, resolve } from 'aurelia';
import { UiService } from '../../services';
import template from './app-footer.html';

// The page footer: legal links (which open the legal-modal via UiService) plus social links,
// the copyright line with the current year, the non-affiliation note, and the "MADE IN PR" mark.
// Presentational state lives in UiService.
export class AppFooterElement {
  readonly ui: UiService = resolve(UiService);
}

export const AppFooter = CustomElement.define({
  name: 'app-footer',
  template,
  // Render the <footer> in place (no host wrapper) so block-flow spacing is unchanged.
  containerless: true
}, AppFooterElement);
